import KnowledgeTestBox from './KnowledgeTestBox.vue';

export default KnowledgeTestBox;
